import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/terms-conditions/profile/loading';

export const Route = createFileRoute('/_private/settings/terms-conditions/$id')({
  pendingComponent: Loading,
});
